import React from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {useUser} from 'client/common/contexts/user';
import Block from 'client/common/components/block';

const i18n = I18N.creatives.creativeSettings;
const b = b_.with('creative-settings-form');

export default function LanguageBlock() {
    const user = useUser();

    if (!user?.info?.uid || user?.info?.settings?.country_id === 225) {
        return null;
    }

    return (
        <Block
            className={b('language-block')}
            header={i18n.language.label}
            description={i18n.language.desc}
        />
    );
}
